<template>
  <crud-create :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @create="create"
               @close="$emit('close')"
  >
    <cash-register-form ref="form" v-model="form" :input-errors="inputErrors" @save="create" />
  </crud-create>
</template>

<script>
import CashRegisterProvider from "../../../../providers/CashRegisterProvider";
import {CrudCreate, ClientError} from '@dracul/common-frontend'
import CashRegisterForm from "../../../../forms/CashRegisterForm";

export default {
  name: "CashRegisterCreate",
  components: { CashRegisterForm, CrudCreate },
  props:{
    open: {type: Boolean, default: true}
  },
  data() {
    return {
      title: 'delivery.cashRegister.creating',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      form: {
        name: '',
        users: [],
        active: true
      }
    }
  },
  methods: {
    create() {
      if (this.$refs.form.validate()) {
        this.loading = true
        CashRegisterProvider.createCashRegister(this.form).then(r => {
              if (r) {
                this.$emit('itemCreated', r.data.createCashRegister)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }
    }
  },
}
</script>
